import { render, staticRenderFns } from "./ConfirmPrivacyOptionsModal.vue?vue&type=template&id=0680f128"
import script from "./ConfirmPrivacyOptionsModal.vue?vue&type=script&lang=js"
export * from "./ConfirmPrivacyOptionsModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPrivacyOptionsModal.vue?vue&type=style&index=0&id=0680f128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports